export default {
    atualizarOdontograma: false
}